export class Category {
  name: string;
  count = 0;

  constructor(name: string, count?: number) {
    this.name = name;
    if (count) this.count = count;
  }
}

export interface AccountsUser {
  user_id: string;
  subscribed: boolean;
  email: string;
  email_subscribed: boolean;
  access_token: string;
  third_party_data: any;
}

export interface LoyaltyProgramCoupon {
  id: number;
  loyaltyProgramId: number;
  couponId: number;
  externalId: string;
  validFrom: Date;
  validTo: Date;
  availableFrom: Date;
  availableTo: Date;
  redemptionMethod: string;
}

/* Enum of the authentication sources */
export enum AuthProvider {
  GOOGLE,
  FACEBOOK,
  EMAIL,
  PG, // P&G Everyday
}

export type SearchMode = 'sl' | 'global';

/* List of experiments */
export type Experiment = 'disabled';

/* List of variants for each experiment */
export type DefaultVariants = 'disabled';

export class StringEnum {
  constructor(public value: string) {}
  toString() {
    return this.value;
  }
}

export type ShoppingListOpVerb = 'post' | 'delete';
export type ShoppingListOpType = 'flyer_item_clipping' | 'list_item' | 'photo' | 'ecom_item_clipping';

export interface ShoppingListOp {
  verb: ShoppingListOpVerb;
  object: {
    type: ShoppingListOpType;
    id?: string;
    [key: string]: any;
  };
}

export interface SLSyncable {
  id: string;
  commitVersion: number;

  createOp(verb: ShoppingListOpVerb, modify?: boolean): ShoppingListOp;
}
